import { Box, BoxProps, Link } from '@mui/material';
// @mui
import { useTheme } from '@mui/material/styles';
import { forwardRef } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useThemeSettingsContext } from '../settings/ThemeSettingsContext';

export interface LogoProps extends BoxProps {
  disabledLink?: boolean;
  invertColor?: boolean;
  width?: number;
  height?: number;
  implicitTheme?: string;
}

const Logo = forwardRef<HTMLDivElement, LogoProps>(
  (
    {
      disabledLink = false,
      invertColor = false,
      width = 40,
      height = 40,
      sx,
      implicitTheme,
      ...other
    },
    _ref,
  ) => {
    const theme = useTheme();

    const { themeMode } = useThemeSettingsContext();

    const _PRIMARY_LIGHT = theme.palette.primary.light;

    const _PRIMARY_MAIN = theme.palette.primary.main;

    const _PRIMARY_DARK = theme.palette.primary.dark;

    // OR using local (public folder)
    // -------------------------------------------------------
    const logo =
      (themeMode || implicitTheme === 'dark') && !invertColor ? (
        <Box
          component="img"
          src="/logo/simbolo_transp_dark.png"
          sx={{ width, height, cursor: 'pointer', ...sx }}
        />
      ) : (
        <Box
          component="img"
          src="/logo/simbolo_transp_light.png"
          sx={{ width, height, cursor: 'pointer', ...sx }}
        />
      );

    // const logo = (
    //   <Box
    //     ref={ref}
    //     component="div"
    //     sx={{
    //       width: 40,
    //       height: 40,
    //       display: 'inline-flex',
    //       ...sx,
    //     }}
    //     {...other}
    //   >
    //     <svg
    //       width="64"
    //       height="64"
    //       viewBox="0 0 512 512"
    //       fill="none"
    //       xmlns="http://www.w3.org/2000/svg"
    //     >
    //       <path
    //         fillRule="evenodd"
    //         clipRule="evenodd"
    //         d="M386.353 174.191C383.786 165.968 378.167 158.541 369.433 153.821L288.086 109.857C267.2 98.5696 242.044 98.5181 221.112 109.72L183.628 129.78C176.097 133.811 173.259 143.183 177.29 150.713C181.32 158.244 190.692 161.082 198.223 157.052L235.707 136.991C247.481 130.69 261.631 130.719 273.38 137.068L354.727 181.032C357.63 182.601 357.78 186.562 355.323 188.426L386.353 174.191Z"
    //         fill="#ACCDFF"
    //       />
    //       <path
    //         d="M229.024 387.112L146.535 342.739C136.211 337.186 129.771 326.409 129.771 314.686V219.255C129.771 204.914 144.979 195.681 157.702 202.298L240.034 245.114C250.577 250.597 257.191 261.493 257.191 273.376V329.227V370.279C257.191 384.738 241.757 393.961 229.024 387.112Z"
    //         fill="#3F91E8"
    //       />
    //       <path
    //         d="M241.74 282.772L151.863 322.029C149.332 323.135 149.184 326.669 151.614 327.982L236.851 374.029C239.059 375.222 241.74 373.623 241.74 371.113V282.772Z"
    //         fill="#398BE0"
    //       />
    //       <g filter="url(#filter0_f_1873_8891)">
    //         <path
    //           d="M241.145 355.171L250.188 407.619C252.698 422.174 237.697 433.471 224.401 427.039L150.977 391.519C150.977 391.519 104.192 370.863 90.6628 343.732C74.0242 310.366 81.0719 249.135 107.403 222.858C123.806 206.488 144.874 216.781 144.874 216.781V254.973C144.874 262.722 149.794 269.616 157.123 272.135L241.145 301.018V355.171Z"
    //           fill="#41A5DE"
    //           fillOpacity="0.4"
    //         />
    //       </g>
    //       <path
    //         fillRule="evenodd"
    //         clipRule="evenodd"
    //         d="M303.848 17.877C274.263 2.58768 239.177 2.24789 209.301 16.9614L67.6162 86.7398C59.4064 90.7831 56.0287 100.716 60.0719 108.926C64.1152 117.136 74.0483 120.514 82.2582 116.47L223.943 46.6919C244.385 36.6248 268.391 36.8573 288.633 47.3184L444.508 127.872C452.686 132.099 452.41 143.888 444.042 147.727L268.838 228.1C260.083 232.116 249.958 231.824 241.448 227.311L143.365 175.291L94.5344 149.792C61.438 132.509 21.8134 156.519 21.8134 193.856V344.957C21.8134 376.069 39.2435 404.559 66.9442 418.724L206.983 490.332C236.758 505.558 272.008 505.681 301.888 490.664L445.144 418.666C473.129 404.602 490.791 375.959 490.791 344.639V219.806C490.791 210.655 483.372 203.236 474.22 203.236C465.069 203.236 457.65 210.655 457.65 219.806V344.639C457.65 363.431 447.053 380.617 430.262 389.055L287.007 461.052C266.562 471.327 242.444 471.243 222.071 460.826L82.0323 389.217C65.4119 380.718 54.9539 363.624 54.9539 344.957V193.856C54.9539 181.411 68.162 173.407 79.1942 179.168L127.931 204.618L128.025 204.667L225.92 256.589C243.546 265.937 264.522 266.541 282.656 258.222L457.86 177.849C491.332 162.495 492.437 115.338 459.723 98.431L303.848 17.877Z"
    //         fill="url(#paint0_linear_1873_8891)"
    //       />
    //       <path
    //         fillRule="evenodd"
    //         clipRule="evenodd"
    //         d="M119.857 200.402C116.381 205.725 114.314 212.143 114.314 219.255V314.686C114.314 332.101 123.88 348.11 139.217 356.36L213.684 396.417L225.144 402.355C236.064 407.002 248.307 409.81 257.242 409.81C267.031 409.81 279.229 406.801 289.862 401.859C290.884 401.419 294.97 399.247 295.976 398.697C295.048 399.231 296.942 398.195 295.976 398.697L375.469 355.247C390.65 346.948 400.093 331.026 400.093 313.724V265.251C400.093 256.71 393.169 249.786 384.628 249.786C376.086 249.786 369.162 256.71 369.162 265.251V313.724C369.162 319.716 365.892 325.231 360.633 328.105L278.07 373.234C275.639 374.563 272.673 372.804 272.673 370.034V272.083C272.673 267.532 274.556 263.279 277.733 260.239C275.623 261.002 273.484 261.651 271.325 262.185C259.64 265.075 247.358 264.615 235.911 260.847C239.558 263.922 241.735 268.487 241.735 273.377V370.28C241.735 373.039 238.789 374.799 236.359 373.492L153.87 329.12C148.558 326.262 145.245 320.718 145.245 314.686V219.255C145.245 217.225 146.842 215.732 148.658 215.611L128.025 204.668L127.931 204.618L119.857 200.402Z"
    //         fill="#ACCDFF"
    //       />
    //       <defs>
    //         <filter
    //           id="filter0_f_1873_8891"
    //           x="18.7613"
    //           y="150.652"
    //           width="294.639"
    //           height="341.169"
    //           filterUnits="userSpaceOnUse"
    //           colorInterpolationFilters="sRGB"
    //         >
    //           <feFlood floodOpacity="0" result="BackgroundImageFix" />
    //           <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
    //           <feGaussianBlur stdDeviation="31.4674" result="effect1_foregroundBlur_1873_8891" />
    //         </filter>
    //         <linearGradient
    //           id="paint0_linear_1873_8891"
    //           x1="81.7056"
    //           y1="472.5"
    //           x2="331.409"
    //           y2="210.763"
    //           gradientUnits="userSpaceOnUse"
    //         >
    //           <stop stopColor="#3888FF" />
    //           <stop offset="1" stopColor="#1D72D8" />
    //         </linearGradient>
    //       </defs>
    //     </svg>
    //   </Box>
    // );

    if (disabledLink) {
      return logo;
    }

    return (
      <Link
        component={RouterLink}
        to="/"
        sx={{ display: 'contents' }}
        {...other}
      >
        {logo}
      </Link>
    );
  },
);

export default Logo;
